import React, {useEffect} from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import "./App.css";
import Nav from "./components/NavBar/Nav";
import PrivateRoute from "./components/PrivateRoute";
import {isAuthenticatedContext, userInfosContext} from "./contexts/authContext";
import Admin from "./pages/Admin";
import Profil from "./pages/Profil";
import authApi from "./utils/authApi";
import Home from "./pages/Home/Home";
import Menu from "./components/MenuCard/Menu";

function App() {
  let isAuthenticated = authApi.isAuthenticated();
  let user = authApi.userInfos();

  useEffect(() => {
    authApi.setUp();
    authApi.isAuthenticated();
  });

  return (
    <isAuthenticatedContext.Provider value={isAuthenticated}>
      <userInfosContext.Provider value={user}>
        <Nav />
          <Router >
            <Switch >
              <Route exact path='/' component={Home} />
              <Route exact path='/post/:id' component={Menu} />
              <Route exact path='/profil' component={Profil} />
              {/*<PrivateRoute exact path="/admin" component={Admin} />*/}
            </Switch>
          </Router>
      </userInfosContext.Provider>
    </isAuthenticatedContext.Provider>
  );
}

export default App;
